<template>
  <div class="sq-player-wrap">
    <div :style="{width:width,height:height, margin: 'auto'}" :class="{'kplayer': playerClass,'aplayer': !playerClass}"  :ref="playerName"></div>
  </div>
</template>
<script>
  export default {
    name: 'YPlayer',
    data () {
      return {
        // options: {}
      }
    },
    props: {
      immediate: {
        type: Boolean,
        default: false,
      },
      width: {
        type: String,
        default: '800px',
      },
      height: {
        type: String,
        default: '450px',
      },
      playerName: {
        type: String,
        default: 'yplayer',
      },
      customEventName: {
        type: String,
        default: 'statechanged'
      },
      events: {
        type: Array,
        default: () => []
      },
      video_type: {
        type: String,
        default: '',
      },
      video_url: {
        type: String,
        default: '',
      },
      is_scocket: {
        type: Boolean,
        default: false,
      }
    },
    methods: {
      closeVideo () {
        this.yplayer.closeVideo()
      },
      skipVideo () {
        this.yplayer.skipVideo()
      },
      fullScreenVideo () {
        this.yplayer.fullscreen()
      },
      initVideo () {
        this.$nextTick(() => {
          try {
            const isEnglish = this.$i18n && (this.$i18n.locale === 'en' || (this.$i18n.locale && this.$i18n.locale.indexOf('en') === 0))
            const coverPic = isEnglish ? 'https://file1-tx.classba.cn/america_video.png' : 'https://file1-tx.classba.cn/homepage.png'
            this.options = {
              container: document.getElementById('video_box'),
              preload: 'none',
              autoplay: true,
              video: {
                url: this.video_url,
                pic: coverPic,
              },
              theme: '#FDB550',
              setting: false,
              playbackRates: [1.5, 1.25, 1, 0.75], // speed
              vertical: true,
              pictureinpicture: true,
              fullscreen: {
                full: true,
                fullweb: false
              },
              endpanel: {
                feedbackBtn: false,
                replayBtn: true
              },
              userInfo: Object.assign({
                video_id: '',
                video_url: this.video_url,
              }),
              socket: this.is_scocket
            }
          } catch (e) {
            console.log({e})
          }
          const DEFAULT_EVENTS = [
            'loadeddata',
            'canplay',
            'canplaythrough',
            'play',
            'pause',
            'waiting',
            'playing',
            'ended',
            'error'
          ]
          const emitPlayerState = (event, value, player) => {
            if (event) {
              this.$emit(event, player)
            }
            if (value) {
              this.$emit(this.customEventName, { [event]: value })
            }
          }
          const self = this
          this.options.container = this.$refs[`${this.playerName}`]
          this.yplayer = new window.YPlayer(this.options, function () {
            // events
            const events = DEFAULT_EVENTS.concat(self.events)
            // watch events
            const onEdEvents = {}
            for (let i = 0; i < events.length; i++) {
              if (typeof events[i] === 'string' && onEdEvents[events[i]] === undefined) {
                (event => {
                  onEdEvents[event] = null
                  this.on(event, () => {
                    emitPlayerState(event, true, this)
                  })
                })(events[i])
              }
            }
            self.$emit('ready', this)
          })
        })
      },
    },
    mounted: function () {
      setTimeout(() => {
        if (this.video_url) {
          this.initVideo()
        }
      }, 1000)
    },
    computed: {
      playerClass () {
        return this.playerName == 'knowledge'
      },
      getVideoUrl () {
        return this.video_url
      }
    },
    watch: {
      video_url (newV, oldV) {
        console.log(newV, '--oldV'+oldV)
        if (newV) {
          this.initVideo()
        }
      }
    },
    beforeDestroy: function () {
      // console.log(this)
      // this.yplayer && this.yplayer.destroy();
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/video.vue